import React, { useEffect, useState } from 'react';
import DashboardMessagesBlock from './DashboardMessagesBlock';
import axios from 'axios';
import DashboardConversationsBlock from './DashboardConversationsBlock';

const Dashboard = ({ currentUser }) => {
    console.log(currentUser);
    const [organizationId, setOrganizationId] = useState(currentUser?.organization);
    const [messageStats, setMessageStats] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            const res = await axios.post('https://gambot.azurewebsites.net/api/Webhooks/GetTotalMessagesByOrganization', {
                organizationId: organizationId  
            });
            setMessageStats(res.data?.Data);
        };

        fetchStats();
    }, [organizationId]);

    return (
        <div>
            <DashboardMessagesBlock data={messageStats} currentUser={currentUser} />
            <DashboardConversationsBlock currentUser={currentUser}></DashboardConversationsBlock>
        </div>
    );
};

export default Dashboard;
